"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNumber = isNumber;
exports.isNumberOrNull = isNumberOrNull;
exports.isTooLargeNumber = isTooLargeNumber;
exports.moneyOptionalValidate = moneyOptionalValidate;
exports.moneyValidate = moneyValidate;
exports.numberOrNullTest = numberOrNullTest;
exports.precision = precision;

var _bignumber = _interopRequireDefault(require("bignumber.js"));

var yup = _interopRequireWildcard(require("yup"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Returns a validator function that tests how much decimal places a value has.
 * Used by yup library for custom testing
 *
 * @param {number} places number of decimal places allowed
 */
function precision(places) {
  /**
   * validation function
   *
   * @param {number} value value to test for decimal places
   * @returns {boolean} is the number of decimal places less or equal to the limit
   */
  return function (value) {
    // empty value should be considered true, let the other validators check if required
    if (!value) return true;
    return new _bignumber["default"](value).decimalPlaces() <= places;
  };
}
/**
 * Use this to validate required money input,
 * or number input where decimals are allowed
 */


function moneyValidate() {
  var errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Value must be a valid number (e.g. 32.20)';
  return yup.mixed().test('two-decimal-places', errorMessage, precision(2)).test('is-number', errorMessage, isNumber).test('is-too-large-number', 'Cannot set a value larger than 100.000.000,00', isTooLargeNumber);
}
/**
 * Use this to validate money input,
 * or number input where decimals are allowed.
 * Also allows empty values
 */


function moneyOptionalValidate() {
  var errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Value must be a valid number (e.g. 32.20) or empty';
  return yup.mixed().test('two-decimal-places', errorMessage, precision(2)).test('is-number-or-null', errorMessage, isNumberOrNull).test('is-too-large-number', 'Cannot set a value larger than 100.000.000,00', isTooLargeNumber);
}

function numberOrNullTest(errorMessage) {
  return yup.mixed().test('number-or-null', errorMessage, isNumberOrNull);
}

function isNumberOrNull(value) {
  if (value === null || value === '') return true;
  return isNumber(value);
}

function isNumber(value) {
  // will return null for invalid numbers
  // will return 0 for integers
  // will return number of decimal places for floating numbers
  return new _bignumber["default"](value).decimalPlaces() !== null;
}
/**
 * Check wether the passed value is larger than 100 million.
 * If it's not a number then just ignore it, let other validation take care of it.
 */


function isTooLargeNumber(value) {
  var numericValue = parseFloat(value);
  if (Number.isNaN(numericValue)) return true;
  var oneHundredMillion = 100000000;
  return numericValue <= oneHundredMillion;
}